"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridHeader = exports.GridHeaderColumn = void 0;

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = __importDefault(require("react"));

const styles_1 = require("./styles");

const Sort_1 = __importDefault(require("../Icons/Sort"));

const GridHeaderColumn = props => {
  const {
    title,
    sortable = true,
    dir,
    name,
    onSortChange,
    stylesOverride
  } = props;

  const onClicked = e => {
    if (!sortable) {
      return false;
    }

    if (!onSortChange) {
      return false;
    }

    onSortChange({
      column: name,
      dir: dir === 'asc' ? 'desc' : 'asc'
    }, e);
  };

  if ((name === null || name === void 0 ? void 0 : name.length) > 0) {
    return (0, jsx_runtime_1.jsxs)(styles_1.StyledGridHeaderColumn, Object.assign({
      onClick: onClicked,
      sortable: sortable,
      "aria-label": "grid-column",
      stylesOverride: stylesOverride
    }, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.StyledGridHeaderColumnText, {
        children: title
      }, void 0), sortable && (0, jsx_runtime_1.jsx)(styles_1.StyledGridHeaderColumnSortIcon, {
        children: (0, jsx_runtime_1.jsx)(Sort_1.default, {
          sort: dir
        }, void 0)
      }, void 0)]
    }), void 0);
  }

  return null;
};

exports.GridHeaderColumn = GridHeaderColumn;

const GridHeader = props => {
  const {
    children,
    bgColor,
    sortable = true,
    onSortChange,
    sort,
    stickyHeader,
    top,
    gridTemplateColumns
  } = props;

  if (!children) {
    return null;
  }

  return (0, jsx_runtime_1.jsx)(styles_1.StyledGridHeader, Object.assign({
    bgColor: bgColor,
    stickyHeader: stickyHeader,
    top: top,
    gridTemplateColumns: gridTemplateColumns,
    "aria-label": "grid-header"
  }, {
    children: react_1.default.Children.map(children, child => (0, jsx_runtime_1.jsx)(exports.GridHeaderColumn, {
      title: child.props.title,
      name: child.props.name,
      sortable: sortable && child.props.sortable,
      onSortChange: sortable ? onSortChange : undefined,
      dir: child.props.name === (sort === null || sort === void 0 ? void 0 : sort.column) ? sort.dir || 'asc' : undefined,
      width: child.props.width,
      stylesOverride: child.props.stylesOverride
    }, `col-${child.props.name}`))
  }), void 0);
};

exports.GridHeader = GridHeader;